// export this package's api
import Cascader from './Cascader';
export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-cascader@0.12.1@rc-cascader/es/index.js
// module id = 463
// module chunks = 0 1